"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvocationResultType = void 0;
var InvocationResultType;
(function (InvocationResultType) {
    InvocationResultType["Invalid"] = "validation_failed";
    InvocationResultType["Succeeded"] = "succeeded";
    InvocationResultType["Error"] = "unhandled_exception";
    InvocationResultType["NotAuthorized"] = "not_authorized";
    InvocationResultType["RequestError"] = "request_exception";
})(InvocationResultType = exports.InvocationResultType || (exports.InvocationResultType = {}));
//# sourceMappingURL=InvocationResult.js.map